function caseInsensitiveSort(s1, s2) {
  const s1lower = s1.toLowerCase();
  const s2lower = s2.toLowerCase();
  // eslint-disable-next-line no-nested-ternary
  return s1lower > s2lower ? 1 : s1lower < s2lower ? -1 : 0;
}

export function sortOrderItems(orderItems) {
  const NO_SALES_TYPE_NAME = 'No Sales Type';
  const orderItemsBySalesType = {};
  Object.keys(orderItems)
    .filter((salesType) => salesType !== NO_SALES_TYPE_NAME)
    .sort(caseInsensitiveSort)
    .forEach((salesType) => {
      orderItemsBySalesType[salesType] = orderItems[salesType];
    });

  const orderItemsWithNoSalesType = orderItems[NO_SALES_TYPE_NAME];

  return orderItemsWithNoSalesType
    ? {
        ...orderItemsBySalesType,
        [NO_SALES_TYPE_NAME]: orderItemsWithNoSalesType,
      }
    : orderItemsBySalesType;
}
